import styles from './styles.module.scss';

interface ContentLoaderProps {
  children: JSX.Element | undefined;
  content: unknown;
  isFetching: boolean;
  emptyMessage?: string;
  fetchingMessage?: string;
}

export function ContentLoader({
  isFetching, fetchingMessage, content, emptyMessage, children,
}: ContentLoaderProps): JSX.Element | null {
  const isContentEmpty = (): boolean => {
    if (Array.isArray(content)) {
      return !content.length;
    }
    if (typeof content === 'object' && content !== null) {
      return !Object.keys(content).length;
    }
    return !content;
  };

  if (!children) return null;
  if (isFetching) {
    return <p className={styles.fetchingStatus}>{fetchingMessage}</p>;
  }
  if (isContentEmpty()) {
    return <p className={styles.noData}>{emptyMessage}</p>;
  }
  return children;
}
